import React, { useMemo } from 'react';
import { Controller, type Control } from 'react-hook-form';
import { DatePicker, Input, Label } from '@shared/components';
import { dateKeyToLocalDate, toDateKey } from '@features/quote/utils/dateKey';
import type { SmriqLastCompletedServiceFormValues } from '../../../../schemas/smriqLastCompletedService.schema';

interface ServiceDetailsFieldsProps {
    control: Control<SmriqLastCompletedServiceFormValues>;
    maxDate: string;
    disabled: boolean;
}

export const ServiceDetailsFields: React.FC<ServiceDetailsFieldsProps> = ({
    control,
    maxDate,
    disabled,
}) => {
    const maxDateValue = useMemo(() => dateKeyToLocalDate(maxDate), [maxDate]);
    return (
        <>
            <div>
                <Label htmlFor="smriq_lcs_completed_date" required>
                    Date completed
                </Label>
                <Controller
                    name="completed_date"
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                        <DatePicker
                            id="smriq_lcs_completed_date"
                            value={dateKeyToLocalDate(field.value) ?? null}
                            onChange={(date) => field.onChange(date ? (toDateKey(date) ?? '') : '')}
                            maxDate={maxDateValue}
                            disabled={disabled}
                            error={!!error}
                            hint={error?.message}
                            aria-invalid={!!error}
                        />
                    )}
                />
            </div>
            <div>
                <Label htmlFor="smriq_lcs_completed_mileage" required>
                    Mileage at service
                </Label>
                <Controller
                    name="completed_mileage"
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                        <Input
                            id="smriq_lcs_completed_mileage"
                            type="number"
                            inputMode="numeric"
                            min="0"
                            max="1000000"
                            value={field.value}
                            onChange={field.onChange}
                            onBlur={field.onBlur}
                            disabled={disabled}
                            error={!!error}
                            hint={error?.message}
                            hintId="smriq_lcs_completed_mileage-hint"
                            aria-invalid={!!error}
                            aria-required
                            aria-describedby={
                                error ? 'smriq_lcs_completed_mileage-hint' : undefined
                            }
                        />
                    )}
                />
            </div>
        </>
    );
};
